import { render, staticRenderFns } from "./UpdateBoMaxLossAmount.vue?vue&type=template&id=356ae9d5&scoped=true"
import script from "./UpdateBoMaxLossAmount.vue?vue&type=script&lang=js"
export * from "./UpdateBoMaxLossAmount.vue?vue&type=script&lang=js"
import style0 from "./UpdateBoMaxLossAmount.vue?vue&type=style&index=0&id=356ae9d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ae9d5",
  null
  
)

export default component.exports